(function() { window.GUID_0b8ee4d1_4f45_4066_a281_a8b9458484bd = { getGuid: function() { return "0b8ee4d1-4f45-4066-a281-a8b9458484bd"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SportId;
        (function (SportId) {
            SportId[SportId["Badminton"] = 1] = "Badminton";
            SportId[SportId["Dart"] = 2] = "Dart";
            SportId[SportId["Volleyball"] = 3] = "Volleyball";
            SportId[SportId["Pool"] = 4] = "Pool";
            SportId[SportId["Other"] = 5] = "Other";
            SportId[SportId["Bocce"] = 6] = "Bocce";
            SportId[SportId["Foosball"] = 7] = "Foosball";
            SportId[SportId["Bowling"] = 8] = "Bowling";
            SportId[SportId["Tennis"] = 9] = "Tennis";
            SportId[SportId["CornHole"] = 10] = "CornHole";
            SportId[SportId["PickleBall"] = 11] = "PickleBall";
            SportId[SportId["VideoGames"] = 12] = "VideoGames";
            SportId[SportId["HorseShoes"] = 13] = "HorseShoes";
            SportId[SportId["Shuffleboard"] = 14] = "Shuffleboard";
            SportId[SportId["Skeeball"] = 15] = "Skeeball";
            SportId[SportId["Basketball"] = 16] = "Basketball";
            SportId[SportId["TableTennis"] = 17] = "TableTennis";
            SportId[SportId["AirHockey"] = 18] = "AirHockey";
        })(SportId = Enumeration.SportId || (Enumeration.SportId = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SportId.pre.js.map
